var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7086 5.29182C13.3502 3.93349 11.4252 3.15016 9.30855 3.36682C6.25022 3.67516 3.73355 6.15849 3.39189 9.21682C2.93355 13.2585 6.05855 16.6668 10.0002 16.6668C12.6586 16.6668 14.9419 15.1085 16.0086 12.8668C16.2752 12.3085 15.8752 11.6668 15.2586 11.6668C14.9502 11.6668 14.6586 11.8335 14.5252 12.1085C13.5836 14.1335 11.3252 15.4168 8.85855 14.8668C7.00855 14.4585 5.51689 12.9502 5.12522 11.1002C4.42522 7.86682 6.88355 5.00016 10.0002 5.00016C11.3836 5.00016 12.6169 5.57516 13.5169 6.48349L12.2586 7.74182C11.7336 8.26682 12.1002 9.16682 12.8419 9.16682H15.8336C16.2919 9.16682 16.6669 8.79182 16.6669 8.33349V5.34182C16.6669 4.60016 15.7669 4.22516 15.2419 4.75016L14.7086 5.29182Z",
    fill: "#007B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRefresh);
export default __webpack_public_path__ + "static/media/ic_refresh.2605e914dcee1f7d7530a815d7303729.svg";
export { ForwardRef as ReactComponent };